import {CommonReducer, ReducerFromState} from "../../@types/reducers";
import {BetfairRefsObject} from "../../@types/response";

export const getBetfairRefs = (state: ReducerFromState<CommonReducer>): BetfairRefsObject => state.common.betfairRefs;
